import DomainEntity from '@/models/DomainEntity'

export default class StrategyOffers extends DomainEntity {
  static get collectionName() {
    return 'strategyoffers/'
  }

  static get parentKey() {
    return 'strategy'
  }

  static defaults() {
    return {
      add: [],
      update: {},
      delete: [],
      needNewContracts: true,
    }
  }
}
